import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationCashsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-cashs-create',
  templateUrl: 'configuration-cashs-create.html',
})
export class ConfigurationCashsCreatePage {

  public form: FormGroup;
  public cash: any;
  update_state: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public translate: TranslateService) {

    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    this.configurationServices.getcashs(this.globals.restaurant_uid);
    loadingPopup.dismiss();


    //Params
    this.update_state = this.navParams.get('update_state');
    this.cash = this.navParams.get('cash');


    if (this.navParams.get('update_state')) {
      //this.configurationServices.getCashsCount(this.globals.restaurant_uid);
      this.form = fb.group({
        name: [this.cash.name, Validators.compose([Validators.required])],
        number: [this.cash.number],
      });

    } else {
      this.form = fb.group({
        name: ['', Validators.compose([Validators.required])],
        number: [0],
      });
    }

  }


  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-nombre-caja-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  insert() {
    this.configurationServices.afs.collection('cashs').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': this.form.value.name,
      'number': 0,
      'history': [],
    }).then(doc => {
      this.globals.GAtrackView('Configuration', 'Configuration - Cashs - Create', this.globals.restaurant.email, 'Create/Update', 'Create cash', 'Configuration', this.form.value.name);
      this.navCtrl.pop();
    });
  }

  update() {
    if (!this.cash.history) {
      this.cash.history = [];
    }
    this.configurationServices.afs.collection('cashs').doc(this.cash.UID).update({
      'name': this.form.value.name,
      'number': this.cash.number,
      'history': this.cash.history,
    }).then(() => {
      this.globals.GAtrackView('Configuration', 'Configuration - Cashs - Update', this.globals.restaurant.email, 'Create/Update', 'Update cash', 'Configuration', this.form.value.name);
      this.navCtrl.pop();
    });
  }

  delete() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-caja'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo') + ' ' + this.translate.instant('instant-seguro-quieres-eliminar-caja'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.deleteCash();
          }
        }
      ]
    });
    alert.present();

  }


  deleteCash() {
    this.configurationServices.afs.doc('cashs/' + this.cash.UID).delete();
    this.navCtrl.pop();
  }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-cashs/configuration-cashs-create/configuration-cashs-create.ts